
/* SANTO CAFÉ SKIN JS — v23 gedrag + echt Shopify product-form */
(function(){
  var h=document.querySelector('.santo .title-panel h1');
  function fit(){
    if(!h) return;
    h.style.fontSize='';
    var fs=parseFloat(getComputedStyle(h).fontSize), guard=0;
    while(h.scrollWidth>h.clientWidth&&fs>11&&guard<60){fs-=.5;h.style.fontSize=fs+'px';guard++;}
  }
  window.addEventListener('resize',fit);
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(fit);}
  fit(); window.addEventListener('load',fit);
})();
(function(){
  var box=document.querySelector('[data-buybox]');
  if(!box) return;
  var UNIT=parseFloat(box.dataset.unit)||8.95,
      DISCOUNT=parseFloat(box.dataset.discount)||0,
      THRESHOLD=parseFloat(box.dataset.threshold)||35,
      MAX=parseInt(box.dataset.max,10)||6,
      hasPlans=box.dataset.hasPlans==='true';
  var state={mode:hasPlans?'subscription':'onetime',bags:2,planId:''};
  var doc=document;
  function el(s,root){return (root||box).querySelector(s)}
  var variantInput=el('[data-variant-input]'), qtyInput=el('[data-qty-input]'), planInput=el('[data-plan-input]');
  var firstPlan=el('[data-freq-opt]');
  if(firstPlan){state.planId=firstPlan.dataset.planId||'';}
  box.querySelectorAll('[data-type]').forEach(function(b){b.addEventListener('click',function(){
    box.querySelectorAll('[data-type]').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});
    if(variantInput&&b.dataset.variantId){variantInput.value=b.dataset.variantId;}
    if(b.dataset.price){UNIT=parseFloat(b.dataset.price);}
    render();
  })});
  box.querySelectorAll('[data-step]').forEach(function(b){b.addEventListener('click',function(){state.bags=Math.min(MAX,Math.max(1,state.bags+parseInt(b.dataset.step,10)));render()})});
  var ot=el('[data-onetime-toggle]');
  if(ot){ot.addEventListener('click',function(){state.mode=state.mode==='subscription'?'onetime':'subscription';render()});}
  box.querySelectorAll('[data-freq-opt]').forEach(function(b){b.addEventListener('click',function(){
    state.planId=b.dataset.planId||'';
    box.querySelectorAll('[data-freq-opt]').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});
    render();
  })});
  var euro=function(n){return '\u20AC'+n.toFixed(2)};
  function set(sel,fn){var e=el(sel); if(e){fn(e);} }
  function render(){
    var std=state.bags*UNIT, sub=state.mode==='subscription'&&hasPlans;
    var now=sub?std*(1-DISCOUNT):std;
    set('[data-step="-1"]',function(e){e.disabled=state.bags<=1});
    set('[data-step="1"]',function(e){e.disabled=state.bags>=MAX});
    set('[data-bags]',function(e){e.textContent=state.bags});
    if(qtyInput){qtyInput.value=state.bags;}
    if(planInput){planInput.value=sub?state.planId:''; planInput.disabled=!sub;}
    set('[data-freq-field]',function(e){e.style.display=sub?'':'none'});
    set('[data-controls]',function(e){e.classList.toggle('is-single',!sub)});
    set('[data-mode-name]',function(e){e.textContent=sub?(box.dataset.tSubName||'Subscription'):(box.dataset.tOnetimeName||'One-time purchase')});
    set('[data-mode-sub]',function(e){e.textContent=sub?(box.dataset.tSubSub||'Pause, skip or cancel anytime'):(box.dataset.tOnetimeSub||'Pay once, no recurring delivery')});
    set('[data-mode-badge]',function(e){e.style.display=sub?'':'none'});
    if(ot){ot.textContent=sub?(box.dataset.tOnetime||'Prefer to try once? Order a single bag \u2192'):(box.dataset.tBack||'\u2190 Back to subscription');}
    set('[data-price-now]',function(e){e.textContent=euro(now)});
    set('[data-price-was]',function(e){e.style.display=sub?'':'none'; e.textContent=euro(std)});
    set('[data-price-save]',function(e){e.style.display=sub?'':'none'});
    set('[data-price-then]',function(e){e.textContent=sub?((box.dataset.tThen||'then {p} / month \u00B7 cancel anytime').replace('{p}',euro(std))):(box.dataset.tOnceNote||'One-time order \u00B7 no renewal')});
    set('[data-cta]',function(e){e.textContent=sub?(box.dataset.tCtaSub||'Start your subscription'):((box.dataset.tAddcart||'Add to cart')+' \u00B7 '+euro(std))});
    set('[data-ship-fill]',function(e){e.style.width=Math.min(100,std/THRESHOLD*100).toFixed(0)+'%'});
    set('[data-ship-note]',function(e){
      if(std>=THRESHOLD){e.innerHTML=box.dataset.tFree||'<strong>Free shipping unlocked</strong> \u2713';}
      else{var need=Math.ceil((THRESHOLD-std)/UNIT);var tm=need>1?(box.dataset.tMoren||'Add <strong>{n} more bags</strong> for free shipping'):(box.dataset.tMore1||'Add <strong>1 more bag</strong> for free shipping');e.innerHTML=tm.replace('{n}',need);}
    });
    var sp=doc.querySelector('[data-sticky-price]'); if(sp){sp.textContent=euro(now);}
    var sw=doc.querySelector('[data-sticky-was]'); if(sw){sw.style.display=sub?'':'none'; sw.textContent=euro(std);}
    var ss=doc.querySelector('[data-sticky-sub]'); if(ss){
      var freqBtn=box.querySelector('[data-freq-opt][aria-pressed="true"]');
      var fl=freqBtn?(freqBtn.dataset.shortLabel||freqBtn.textContent.trim().toLowerCase()):'monthly';
      ss.textContent=state.bags+' '+(state.bags>1?(box.dataset.tBagwordn||'bags'):(box.dataset.tBagword1||'bag'))+(sub?(' \u00B7 '+fl+' \u00B7 '+(box.dataset.tCancel||'cancel anytime')):(' \u00B7 '+(box.dataset.tOnetimeShort||'one-time')));
    }
    var sc=doc.querySelector('[data-sticky-cta]'); if(sc){sc.textContent=sub?(box.dataset.tStickySub||'Subscribe'):(box.dataset.tAddcart||'Add to cart');}
  }
  render();
  var bar=doc.querySelector('[data-sticky]');
  if(bar){
    var scta=doc.querySelector('[data-sticky-cta]');
    if(scta){scta.addEventListener('click',function(){box.scrollIntoView({behavior:'smooth',block:'center'})});}
    var boxBelow=false;
    function footVisible(){
      var v=false;
      doc.querySelectorAll('footer').forEach(function(f){if(f.dataset.santoVis==='1'){v=true;}});
      return v;
    }
    function updBar(){
      var on=boxBelow&&!footVisible();
      bar.classList.toggle('is-on',on);
      bar.setAttribute('aria-hidden',on?'false':'true');
    }
    var io=new IntersectionObserver(function(es){es.forEach(function(en){
      boxBelow=!en.isIntersecting&&en.boundingClientRect.top<0;
    });updBar();},{threshold:0});
    io.observe(box);
    var fio=new IntersectionObserver(function(es){es.forEach(function(en){
      en.target.dataset.santoVis=en.isIntersecting?'1':'0';
    });updBar();},{threshold:0});
    doc.querySelectorAll('footer').forEach(function(f){fio.observe(f);});
  }
})();
document.addEventListener('click',function(ev){
  var btn=ev.target.closest('.santo .faq button');
  if(!btn) return;
  var faq=btn.parentElement,a=faq.querySelector('.faq-a'),open=faq.hasAttribute('data-open');
  document.querySelectorAll('.santo .faq[data-open]').forEach(function(o){if(o!==faq){o.removeAttribute('data-open');o.querySelector('.faq-a').style.maxHeight=0;o.querySelector('button').setAttribute('aria-expanded','false');}});
  if(open){faq.removeAttribute('data-open');a.style.maxHeight=0;btn.setAttribute('aria-expanded','false');}
  else{faq.setAttribute('data-open','');a.style.maxHeight=a.scrollHeight+'px';btn.setAttribute('aria-expanded','true');}
});
(function(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){document.querySelectorAll('.santo .reveal').forEach(function(e){e.classList.add('is-in')});return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}})},{threshold:.12});
  document.querySelectorAll('.santo .reveal').forEach(function(e){io.observe(e)});
  setTimeout(function(){document.querySelectorAll('.santo .reveal').forEach(function(e){e.classList.add('is-in')})},2500);
})();

/* Theme-editor: secties her-initialiseren na AJAX-reload */
document.addEventListener('shopify:section:load',function(){
  document.querySelectorAll('.santo .reveal').forEach(function(e){e.classList.add('is-in')});
  var h=document.querySelector('.santo .title-panel h1');
  if(h&&document.fonts&&document.fonts.ready){document.fonts.ready.then(function(){
    h.style.fontSize='';var fs=parseFloat(getComputedStyle(h).fontSize),g=0;
    while(h.scrollWidth>h.clientWidth&&fs>11&&g<60){fs-=.5;h.style.fontSize=fs+'px';g++;}
  });}
});

/* Cart: AJAX add-to-cart + native Horizon drawer */
(function(){
  function drawerEl(){return document.querySelector('cart-drawer-component');}
  function openDrawer(){var d=drawerEl();if(d&&typeof d.open==='function'){d.open();return true;}return false;}
  document.addEventListener('click',function(ev){
    var a=ev.target.closest('[data-santo-cart-link]');
    if(a&&drawerEl()){ev.preventDefault();openDrawer();}
  });
  document.addEventListener('submit',function(ev){
    var form=ev.target;
    if(!form||form.tagName!=='FORM')return;
    if(!form.hasAttribute('data-buybox')&&!form.closest('[data-buybox]'))return;
    if(!drawerEl())return; /* page-modus of geen drawer: normale submit */
    ev.preventDefault();
    var cta=form.querySelector('[data-cta]');if(cta){cta.disabled=true;}
    var fd=new FormData(form);
    var ids=[];
    document.querySelectorAll('cart-items-component').forEach(function(el){if(el.dataset.sectionId){ids.push(el.dataset.sectionId);}});
    if(ids.length){fd.append('sections',ids.join(','));fd.append('sections_url',window.location.pathname);}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){if(!r.ok){throw new Error('add failed');}return r.json();})
      .then(function(item){
        return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          var ev2=new Event('cart:update',{bubbles:true});
          ev2.detail={resource:cart,sourceId:'santo-buybox',data:{source:'product-form-component',itemCount:cart.item_count,variantId:String(item.variant_id||''),sections:item.sections||{}}};
          document.dispatchEvent(ev2);
          openDrawer();
        });
      })
      .catch(function(){try{HTMLFormElement.prototype.submit.call(form);}catch(e){window.location='/cart';}})
      .finally(function(){if(cta){cta.disabled=false;}});
  });
})();
